<template>
  <div class="m-question">
    <div class="m-background m-background--graph"></div>
    <Header />
    <div class="m-question__question-wrap">
        <div class="m-question__question-number">{{ question.countInLevel }}</div>
        <div class="m-question__question-text">
          <span v-html="question.text"></span>
        </div>
    </div>
    <div class="l-container l-container--with-questions">
      <div v-if="question.answered" class="columns is-centered">
      <!-- TODO: If question has an "answer" value of 1 or more,
        show "you've answer this already" message -->
        <div class="column is-6">
          <div class="m-speech-bubble m-speech-bubble--no-triangle m-speech-bubble--v-middle">
            <h3 class="u-text--center">You've already answered this question</h3>
            <div>
              <a class="m-btn m-btn__secondary
               m-btn__secondary--with-text
               m-btn__secondary--not-fixed"
              @click="showFeedback(question.id)">See Feedback
                <img class="m-btn__arrow" src="~@/assets/images/white-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="columns is-gapless">
        <div class="column is-4">
          <div class="m-question__media-wrap">
            <!-- <img class="m-question__media"
              :src="question.image" /> -->
            <img class="m-question__media"
              :src="getImageDomain + question.image" />
          </div>
        </div>
        <div class="column is-8">
          <!-- <div class="columns is-multiline"> -->
            <!-- <div class="column is-full" > -->
              <a v-for="response in question.responses"
            :key="response.id" class="m-question__answer"
                @click="answerQuestion(response.cost, question.id, response.id, response.score);">
                <!-- <div class="column is-9"> -->
                  <div class="m-question__answer-text">
                    <span>{{response.text}}</span>
                  </div>
                <!-- </div> -->
                <!-- <div class="column is-3"> -->
                  <div class="m-question__answer-cost">
                    <span>£{{ response.cost | currency }}</span></div>
                <!-- </div> -->
              </a>
            <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Header from '../../components/header/Header';

export default {
  data() {
    return {
      answered: false,
    };
  },
  components: {
    Header,
  },
  computed: {
    ...mapGetters(['getLevel', 'getAllQuestions', 'getQuestionIndex', 'getImageDomain']),
    questions() {
      const getLevel = this.$store.getters.getLevel;
      const theseQuestions = this.getAllQuestions.filter(question => question.level === getLevel);
      return theseQuestions;
    },
    totalQuestions() {
      const allQuestions = this.$store.state.questions;
      return allQuestions.filter(question => question.level === this.$store.state.user.rank).length;
    },
    question() {
      const questionNumber = this.$route.params.id - 1;
      return this.$store.state.questions[questionNumber];
    },
    nextQuestion() {
      const nextQuestion = this.$route.params.id + 1;
      return nextQuestion;
    },
  },
  watchers: {
  },
  methods: {
    ...mapActions(['increaseRank', 'setShowPromotionStatus', 'setGameOverStatus', 'adjustBudget', 'getScore', 'saveAnswer', 'saveScore', 'setQuestionTracker', 'incrementQuestionIndex']),
    answerQuestion(cost, questionId, responseId, score) {
      // Check if the question has already been answered
      this.adjustBudget(cost);
      this.saveAnswer([questionId, responseId]);
      this.saveScore(score);
      this.setQuestionTracker(questionId);
      this.incrementQuestionIndex();
      if (!this.checkForGameOver()) {
        this.checkForPromotion();
        this.$router.push({ name: 'feedback', params: { id: questionId } });
      }
    },
    showFeedback(questionId) {
      this.$router.push({ name: 'feedback', params: { id: questionId } });
    },
    submitLastQuestion() {
      this.increaseLevel();
    },
    checkForPromotion() {
      const userScore = this.$store.state.user.score;
      const userRank = this.$store.state.user.rank + 1;
      const nextRank = this.$store.state.ranks.find(rank => rank.rank_level === userRank);
      if (userScore >= nextRank.rank_achieveAt) {
        this.increaseRank();
        nextRank.rank_achieved = true;
        this.setShowPromotionStatus(true);
      }
    },
    checkForGameOver() {
      const userBudget = this.$store.state.user.budget;
      if (userBudget < 0) {
        this.$router.push({ name: 'gameOverLose' });
        return true;
      }
      return false;
    },
  },
};
</script>


<style lang='scss' scoped>
  .m-question__title {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/questions/Question.vue